import {
  GET_ORGANISMES_PAC,
  GET_PAC_CATEGRY_PARAM,
  SEND_PAC_INFOS,
  SET_ORGANISMES_PAC,
  SET_PAC_CATEGRY_PARAM,
  SET_PAC_OBJECT,
  SET_PAC_RESPONSE,
} from './constants';

export const initialState = {
  isLoadingPACOrganismes: false,
  isLoadingCategories: false,
  isLoadingPACResponse: false,
  pacOrganismes: null,
  pacCategories: null,
  pacObject: {
    TmpListFiles: [],
  },
  responsePAC: null,
};
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case GET_ORGANISMES_PAC:
      return { ...state, isLoadingPACOrganismes: true };
    case SET_ORGANISMES_PAC:
      return {
        ...state,
        pacOrganismes: action.payload,
        isLoadingPACOrganismes: false,
      };
    case SET_PAC_OBJECT:
      return {
        ...state,
        pacObject: {
          ...state.pacObject,
          ...action.payload,
        },
      };
    case GET_PAC_CATEGRY_PARAM:
      return {
        ...state,
        isLoadingCategories: true,
      };
    case SET_PAC_CATEGRY_PARAM:
      return {
        ...state,
        pacCategories: action.payload,
        isLoadingCategories: false,
      };
    case SEND_PAC_INFOS:
      return {
        ...state,
        isLoadingPACResponse: true,
      };
    case SET_PAC_RESPONSE:
      return {
        ...state,
        isLoadingPACResponse: false,
        responsePAC: action.payload,
      };
    default:
      return state;
  }
}
